// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_gen_token.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "./buf/validate/validate_pb";
import type { StatusCode } from "./plugnmeet_common_api_pb";
import { file_plugnmeet_common_api } from "./plugnmeet_common_api_pb";
import type { ClientType } from "./plugnmeet_nats_msg_pb";
import { file_plugnmeet_nats_msg } from "./plugnmeet_nats_msg_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_gen_token.proto.
 */
export const file_plugnmeet_gen_token: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_plugnmeet_common_api, file_plugnmeet_nats_msg]);

/**
 * @generated from message plugnmeet.GenerateTokenReq
 */
export type GenerateTokenReq = Message<"plugnmeet.GenerateTokenReq"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: plugnmeet.UserInfo user_info = 2;
   */
  userInfo?: UserInfo | undefined;
};

/**
 * Describes the message plugnmeet.GenerateTokenReq.
 * Use `create(GenerateTokenReqSchema)` to create a new message.
 */
export const GenerateTokenReqSchema: GenMessage<GenerateTokenReq> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 0);

/**
 * @generated from message plugnmeet.UserInfo
 */
export type UserInfo = Message<"plugnmeet.UserInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: bool is_admin = 3;
   */
  isAdmin: boolean;

  /**
   * @generated from field: bool is_hidden = 4;
   */
  isHidden: boolean;

  /**
   * @generated from field: plugnmeet.UserMetadata user_metadata = 5;
   */
  userMetadata?: UserMetadata | undefined;

  /**
   * default WEB; customer backend sets HYBRID_WEB for native-shell joins
   *
   * @generated from field: plugnmeet.ClientType client_type = 6;
   */
  clientType: ClientType;
};

/**
 * Describes the message plugnmeet.UserInfo.
 * Use `create(UserInfoSchema)` to create a new message.
 */
export const UserInfoSchema: GenMessage<UserInfo> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 1);

/**
 * @generated from message plugnmeet.UserRaisedHand
 */
export type UserRaisedHand = Message<"plugnmeet.UserRaisedHand"> & {
  /**
   * @generated from field: bool is_raised = 1;
   */
  isRaised: boolean;

  /**
   * Unix timestamp (in milliseconds)
   *
   * @generated from field: int64 raised_at = 2 [jstype = JS_STRING];
   */
  raisedAt: string;
};

/**
 * Describes the message plugnmeet.UserRaisedHand.
 * Use `create(UserRaisedHandSchema)` to create a new message.
 */
export const UserRaisedHandSchema: GenMessage<UserRaisedHand> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 2);

/**
 * @generated from message plugnmeet.UserMetadata
 */
export type UserMetadata = Message<"plugnmeet.UserMetadata"> & {
  /**
   * @generated from field: optional string profile_pic = 1;
   */
  profilePic?: string | undefined;

  /**
   * @generated from field: bool is_admin = 2;
   */
  isAdmin: boolean;

  /**
   * @generated from field: optional bool record_webcam = 3;
   */
  recordWebcam?: boolean | undefined;

  /**
   * @generated from field: bool is_presenter = 4;
   */
  isPresenter: boolean;

  /**
   * This field is managed by the server and cannot be set by clients.
   *
   * @generated from field: plugnmeet.UserRaisedHand raised_hand = 5;
   */
  raisedHand?: UserRaisedHand | undefined;

  /**
   * @generated from field: bool wait_for_approval = 6;
   */
  waitForApproval: boolean;

  /**
   * @generated from field: optional string preferred_lang = 7;
   */
  preferredLang?: string | undefined;

  /**
   * @generated from field: plugnmeet.LockSettings lock_settings = 8;
   */
  lockSettings?: LockSettings | undefined;

  /**
   * we'll use this as version control
   *
   * @generated from field: optional string metadata_id = 9;
   */
  metadataId?: string | undefined;

  /**
   * @generated from field: map<string, string> extra_data = 10;
   */
  extraData: { [key: string]: string };

  /**
   * if remain empty then will use value from user_id
   *
   * Next ID: 12
   *
   * @generated from field: optional string ex_user_id = 11;
   */
  exUserId?: string | undefined;
};

/**
 * Describes the message plugnmeet.UserMetadata.
 * Use `create(UserMetadataSchema)` to create a new message.
 */
export const UserMetadataSchema: GenMessage<UserMetadata> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 3);

/**
 * @generated from message plugnmeet.PlugNmeetTokenClaims
 */
export type PlugNmeetTokenClaims = Message<"plugnmeet.PlugNmeetTokenClaims"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * @generated from field: bool is_admin = 4;
   */
  isAdmin: boolean;

  /**
   * @generated from field: bool is_hidden = 5;
   */
  isHidden: boolean;

  /**
   * copied from UserInfo at join-token generation
   *
   * @generated from field: plugnmeet.ClientType client_type = 6;
   */
  clientType: ClientType;
};

/**
 * Describes the message plugnmeet.PlugNmeetTokenClaims.
 * Use `create(PlugNmeetTokenClaimsSchema)` to create a new message.
 */
export const PlugNmeetTokenClaimsSchema: GenMessage<PlugNmeetTokenClaims> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 4);

/**
 * @generated from message plugnmeet.LockSettings
 */
export type LockSettings = Message<"plugnmeet.LockSettings"> & {
  /**
   * @generated from field: optional bool lock_microphone = 1;
   */
  lockMicrophone?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_webcam = 2;
   */
  lockWebcam?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_screen_sharing = 3;
   */
  lockScreenSharing?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_chat = 4;
   */
  lockChat?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_chat_send_message = 5;
   */
  lockChatSendMessage?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_chat_file_share = 6;
   */
  lockChatFileShare?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_private_chat = 7;
   */
  lockPrivateChat?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_whiteboard = 8;
   */
  lockWhiteboard?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_shared_notepad = 9;
   */
  lockSharedNotepad?: boolean | undefined;

  /**
   * @generated from field: optional bool lock_reactions = 10;
   */
  lockReactions?: boolean | undefined;
};

/**
 * Describes the message plugnmeet.LockSettings.
 * Use `create(LockSettingsSchema)` to create a new message.
 */
export const LockSettingsSchema: GenMessage<LockSettings> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 5);

/**
 * @generated from message plugnmeet.GenerateTokenRes
 */
export type GenerateTokenRes = Message<"plugnmeet.GenerateTokenRes"> & {
  /**
   * @generated from field: bool status = 1;
   */
  status: boolean;

  /**
   * @generated from field: string msg = 2;
   */
  msg: string;

  /**
   * @generated from field: plugnmeet.StatusCode status_code = 3;
   */
  statusCode: StatusCode;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string | undefined;
};

/**
 * Describes the message plugnmeet.GenerateTokenRes.
 * Use `create(GenerateTokenResSchema)` to create a new message.
 */
export const GenerateTokenResSchema: GenMessage<GenerateTokenRes> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 6);

/**
 * @generated from message plugnmeet.CustomDesignParams
 */
export type CustomDesignParams = Message<"plugnmeet.CustomDesignParams"> & {
  /**
   * @generated from field: optional string primary_color = 1;
   */
  primaryColor?: string | undefined;

  /**
   * @generated from field: optional string secondary_color = 2;
   */
  secondaryColor?: string | undefined;

  /**
   * @generated from field: optional string background_color = 3;
   */
  backgroundColor?: string | undefined;

  /**
   * @generated from field: optional string background_image = 4;
   */
  backgroundImage?: string | undefined;

  /**
   * @generated from field: optional string header_bg_color = 5;
   */
  headerBgColor?: string | undefined;

  /**
   * @generated from field: optional string footer_bg_color = 6;
   */
  footerBgColor?: string | undefined;

  /**
   * @generated from field: optional string left_side_bg_color = 7;
   */
  leftSideBgColor?: string | undefined;

  /**
   * @generated from field: optional string right_side_bg_color = 8;
   */
  rightSideBgColor?: string | undefined;

  /**
   * @generated from field: optional string custom_css_url = 9;
   */
  customCssUrl?: string | undefined;

  /**
   * @generated from field: optional string custom_logo = 10;
   */
  customLogo?: string | undefined;
};

/**
 * Describes the message plugnmeet.CustomDesignParams.
 * Use `create(CustomDesignParamsSchema)` to create a new message.
 */
export const CustomDesignParamsSchema: GenMessage<CustomDesignParams> = /*@__PURE__*/
  messageDesc(file_plugnmeet_gen_token, 7);

